import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextEditor',
  props: {
    placeholder: { type: String, required: false },
    modelValue: { type: String, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const editor = ref<HTMLElement | null>(null);
let quill: any = null;

onMounted(async () => {
  const Quill = (await import("quill")).default;
  import("quill/dist/quill.snow.css");

  if (editor.value) {
    quill = new Quill(editor.value, {
      theme: "snow",
      placeholder: props.placeholder || "Insert text here ...",
      modules: {
        toolbar: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
          [{ color: [] }, { background: [] }], // <-- Add this
        ],
      },
    });

    if (props.modelValue) {
      //quill.root.innerHTML = props.modelValue;
      quill.clipboard.dangerouslyPasteHTML(props.modelValue || '');
    }

    editor.value.style.height = "200px";

    quill.on("text-change", () => {
      emit("update:modelValue", quill.root.innerHTML);
    });
  }
});

watch(
  () => props.modelValue,
  (newValue) => {
    if (quill && newValue !== quill.root.innerHTML) {
      quill.clipboard.dangerouslyPasteHTML(newValue || '');
    }
  }
);
onBeforeUnmount(() => {
  if (quill) {
    quill = null;
  }
});

const __returned__ = { props, emit, editor, get quill() { return quill }, set quill(v) { quill = v } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})